/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy, Component, EventEmitter, Input, Output,
} from '@angular/core';

export interface ViewOption {
  value: string;
  label: string;
}

let nextId = 0;

// The narrow-screen stand-in for a 2026-design tab bar (DESIGN_SYSTEM.html, Tabs): a full-width native
// select, its "Show" label for screen readers only. Render it next to the tabs and hide whichever doesn't apply, so only one control is exposed.
@Component({
  selector: 'ut-view-picker',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <label class="sr-only" [for]="id">{{ label }}</label>
    <select class="view-picker__select" [id]="id" [value]="value" (change)="selected.emit($any($event.target).value)">
      @for (option of options; track option.value) {
        <option [value]="option.value" [selected]="option.value === value">{{ option.label }}</option>
      }
    </select>
  `,
  styleUrls: ['./view-picker.component.scss'],
})
export class ViewPickerComponent {
  @Input({ required: true }) options: ViewOption[] = [];
  @Input({ required: true }) value = '';
  @Input() label = 'Show';
  @Output() selected = new EventEmitter<string>();

  readonly id = `viewPicker${nextId++}`;
}
